"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTool = void 0;
class GenericTool {
    constructor(TCreator, options) {
        this.annotator = null;
        this.annotation = null;
        this.initialPosition = null;
        this.active = false;
        this.options = new TCreator();
        options && Object.assign(this.options, options);
    }
    activate(annotator) {
        this.annotator = annotator;
        this.active = true;
    }
    deactivate() {
        this.active = false;
        this.annotation = null;
        this.annotator = null;
    }
    isActive() {
        return this.active;
    }
    onMouseDown() {
        this.initialPosition = { ...this.annotator.canvas.getPointer(null) };
    }
    ;
    onMouseMove() { }
    ;
    onMouseUp() {
        return false;
    }
    ;
}
exports.GenericTool = GenericTool;
